import React from 'react';
import { Box, Typography, Chip, Tooltip } from '@mui/material';

export const PLANS = ['trial', 'starter', 'professional', 'enterprise'];
export const STATUSES = ['active', 'trialing', 'inactive', 'suspended', 'cancelled'];

const PLAN_COLORS = { trial: 'default', starter: 'info', professional: 'secondary', enterprise: 'success' };
const STATUS_COLORS = { active: 'success', trialing: 'info', inactive: 'default', suspended: 'warning', cancelled: 'error' };

export const formatLimit = (n) => (n === -1 || n === undefined || n === null || n === '' ? '∞' : Number(n).toLocaleString());
export const usageText = (used, limit) => `${Number(used || 0).toLocaleString()} / ${formatLimit(limit)}`;
export const usagePercent = (used, limit) => (!limit || Number(limit) <= 0 ? 0 : Math.min(100, Math.round((Number(used || 0) / Number(limit)) * 100)));
export const errorMessage = (err, fallback) => err?.response?.data?.message || err?.message || fallback;

export const PlanChip = ({ plan, size = 'small' }) => (
  <Chip label={(plan || 'n/a').toUpperCase()} color={PLAN_COLORS[plan] || 'default'} size={size} variant={plan === 'trial' ? 'outlined' : 'filled'} />
);

export const StatusChip = ({ status, size = 'small' }) => (
  <Chip label={(status || 'n/a').toUpperCase()} color={STATUS_COLORS[status] || 'default'} size={size} />
);

/** "used / limit" with a warning colour when close to the limit. */
export const UsageCell = ({ used, limit, label }) => {
  const pct = usagePercent(used, limit);
  const color = pct >= 100 ? 'error.main' : pct >= 80 ? 'warning.main' : 'text.primary';
  return (
    <Tooltip title={label ? `${label}: ${pct}% of limit` : `${pct}% of limit`}>
      <Typography variant="body2" sx={{ color, whiteSpace: 'nowrap' }}>{usageText(used, limit)}</Typography>
    </Tooltip>
  );
};

export const AdminPageHeader = ({ title, subtitle, actions }) => (
  <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
    <Box>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>{title}</Typography>
      {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>}
    </Box>
    {actions && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>{actions}</Box>}
  </Box>
);
